import { render } from "./StatusMark.vue?vue&type=template&id=5e18f140&scoped=true"
import script from "./StatusMark.vue?vue&type=script&lang=js"
export * from "./StatusMark.vue?vue&type=script&lang=js"

import "./StatusMark.vue?vue&type=style&index=0&id=5e18f140&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e18f140"

export default script